// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"77d069fe","92":"cb18215c","277":"e99869d9","294":"86a57d07","355":"8665acdc","707":"72288f2d","859":"d4e30c9c","871":"adbf38c8"}[chunkId] + ".chunk.js";
};